import { TriangleAlert } from "lucide-react";
import { Link } from "react-router";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

import { formatUsd, type LabBudgetExceededError } from "./errors";

export const LabBudgetAlert = ({
  error,
}: {
  error: LabBudgetExceededError;
}) => (
  <Alert variant="destructive" role="alert">
    <TriangleAlert className="size-4" />
    <AlertTitle>
      {error.limitUsd == null
        ? "Labs budget reached"
        : `${formatUsd(error.limitUsd, error.currency)} Labs budget reached`}
    </AlertTitle>
    <AlertDescription className="space-y-3">
      <p>
        No paid run was queued. The environment max-spend cap
        {error.committedUsd == null
          ? " has been reached"
          : ` has ${formatUsd(
              error.committedUsd,
              error.currency,
            )} committed (${formatUsd(
              error.currentUsd ?? 0,
              error.currency,
            )} spent and ${formatUsd(
              error.reservedUsd ?? 0,
              error.currency,
            )} reserved)`}
        . Increase the Labs budget through the signed runtime configuration
        controls, publish the release, and wait for service readback before
        retrying.
      </p>
      {error.configKey ? (
        <p className="text-xs">
          Runtime control: <code className="font-mono">{error.configKey}</code>
        </p>
      ) : null}
      <Button asChild variant="outline" size="sm">
        <Link to="/feature-flags">Increase budget</Link>
      </Button>
    </AlertDescription>
  </Alert>
);
